import React, {memo} from 'react';
import SimpleAccordion from '@/components/MUI-Components/MUI-Accordian';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Questions = (props: any) => {
    const {accordianData, subpart} = props;
    return (
        <Box>
            <Typography
                variant="h1"
                component="h2"
                mb={3}
                textAlign="center"
                marginBottom={5}
                fontSize={{xs: 35, sm: 48}}
                className="font-headers"
            >
                Frequently Asked Questions
            </Typography>
            <Box>
                <SimpleAccordion accordianData={accordianData} className="panel1a-header" isIconVisible={true} subpart={subpart} />
            </Box>
        </Box>
    );
};

export default memo(Questions);
